export const extractUrlFromPath = (path: string) => {
  const parts = path.split('/');
  if (parts.length > 1) {
    return '/' + parts[1];
  } else {
    return null;
  }
};
